<template>
    <el-dialog :title="$t('buy_dialog.dialog_title')" :visible.sync="showPopup" append-to-body  class="my-dialog-class"> 
        
        <el-form :label-position="'top'" :inline="false"  
            :rules="rules"
            label-width="100%"  
            :model='newRequest'  ref='my-form' @submit.prevent="save" v-loading="loading">
            
             <el-row :gutter="15">
                 <el-col :span="24">
                     <el-form-item :label="$t('buy_dialog.quantity')" prop="quantity" :required="true">
                        <el-input-number :min="1" :max="max_quantity" v-model="newRequest.quantity" class="full-width"></el-input-number>
                     </el-form-item>
                 </el-col>
             </el-row>

             <el-row :gutter="15">
                 <el-col :span="12">
                     <el-form-item :label="$t('buy_dialog.price')" >
                        <el-input v-model="price" :disabled="true" />
                     </el-form-item>
                 </el-col>

                 <el-col :span="12">
                     <el-form-item :label="$t('buy_dialog.request_value')" >
                        <el-input v-model="get_value_of_request" :disabled="true" />
                     </el-form-item>
                 </el-col>
             </el-row>

        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="new_order">{{ $t("buy_dialog.confirm_order") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import settings from "./../../backend/LocalSettings";

export default {
  name: "buy-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      newRequest: { quantity: 0 },
      max_quantity: 100,
      price: 0,
      sell_item_id: 0,
      rules:{
          quantity: [ { required: true } ]
      }
    }
  },
  computed: {
    get_value_of_request: function(){
        var ret = this.price * this.newRequest.quantity;
        return Math.round(ret * 100) / 100;
    },
  },
  methods: {
     show_me: function( sellItem ) {
        this.showPopup           = true;
        this.newRequest.quantity = 1;
        this.price          = parseFloat( sellItem.Price    );
        this.max_quantity   = parseFloat( sellItem.Quantity );
        this.sell_item_id   = sellItem.Id;
    },
   
    new_order: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$http
            .post('dashboard/new_order',  { quantity: this.newRequest.quantity, price: this.price, sell_item_id: this.sell_item_id } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                    var has_error =response.body.Error;
                    if( has_error ){
                        this.$message.error( response.body.ErrorMessage );
                    }else{
                        this.showPopup = false;
                        this.$emit("neworder");
                    }
                } else {
                this.$router.push("/");
                }
            });
          } 
        });

        
    }
  },
  mounted: function() {
      
  }
};
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }
</style>